import { call, put, select, takeLatest } from 'redux-saga/effects';
import {IpaUserExtended} from '../../../shared/sagas/auth/authSlice';
import { AxiosResponse } from 'axios';
import { selectCurrentUser } from '../../../shared/sagas/auth/authSlice';
import { getExistingIntegrations, getCreateNewIntegration, getUpdatePromasApiKey, setExistingPortfolios, setPmIntegrationsError, setSendPortfolioName, setUpdatePromasApiKey } from './pmIntegrationSlice';
import { PmsApi, Configuration, CreateSoftwareIntegrationDto, UpdateIntegrationApiKeyDto, SoftwareIntegrationCredentialTypeEnum } from '@inosio/payments-sdk';

const { REACT_APP_IPA_BASE_PATH } = process.env;
const apiConfig = new Configuration({ basePath: REACT_APP_IPA_BASE_PATH });

export function requestCreateNewIntegration(access_token: string, pmUuid: string, newIntegration: CreateSoftwareIntegrationDto) {
  apiConfig.accessToken = access_token;
  const ipaPmAPI = new PmsApi(apiConfig);

  return ipaPmAPI.createSoftwareIntegration(pmUuid, newIntegration);
}
export function requestGetExistingIntegrations(access_token: string, pmUuid: string, integrationType?: SoftwareIntegrationCredentialTypeEnum) {
  apiConfig.accessToken = access_token;
  const ipaPmAPI = new PmsApi(apiConfig);

  return ipaPmAPI.getExistingPortfolios(pmUuid, integrationType);
}

export function requestUpdateApiKey(access_token: string, pmUuid: string, softwareId: UpdateIntegrationApiKeyDto) {
  apiConfig.accessToken = access_token;
  const ipaPmAPI = new PmsApi(apiConfig);

  return ipaPmAPI.updateApiKey(pmUuid, softwareId);
}

export function* handleCreateNewIntegration(action: { type: typeof getCreateNewIntegration; payload: CreateSoftwareIntegrationDto }) {
  try {
    const currentUser:IpaUserExtended= yield select(selectCurrentUser);
    const response: AxiosResponse<string> = yield call(requestCreateNewIntegration, currentUser.accessToken, currentUser.currentProfile.uuid, action.payload);

    const { data } = response;
    yield put(setSendPortfolioName(data));
  } catch (error: any) {
    yield put(setPmIntegrationsError({ message: error?.response?.data?.message }));
  }
}

export function* handleGetExistingIntegrations(action: { type: typeof getExistingIntegrations; payload: { integrationType?: SoftwareIntegrationCredentialTypeEnum } }) {
  try {
    const currentUser:IpaUserExtended= yield select(selectCurrentUser);
    const response: AxiosResponse<string> = yield call(requestGetExistingIntegrations, currentUser.accessToken, currentUser.currentProfile.uuid, action.payload?.integrationType);

    const { data } = response;
    yield put(setExistingPortfolios(data));
  } catch (error: any) {
    yield put(setPmIntegrationsError({ message: error?.response?.data?.message }));
  }
}

export function* handleUpdateApiKey(action: { type: typeof getUpdatePromasApiKey; payload: UpdateIntegrationApiKeyDto }) {
  try {
    const currentUser:IpaUserExtended= yield select(selectCurrentUser);
    const response: AxiosResponse<string> = yield call(requestUpdateApiKey, currentUser.accessToken, currentUser.currentProfile.uuid, action.payload);

    const { data } = response;
    yield put(setUpdatePromasApiKey(data));
  } catch (error: any) {
    yield put(setPmIntegrationsError({ message: error?.response?.data?.message }));
  }
}

export function* pmIntegrationSaga() {
  yield takeLatest(getCreateNewIntegration.type, handleCreateNewIntegration);
  yield takeLatest(getExistingIntegrations.type, handleGetExistingIntegrations);
  yield takeLatest(getUpdatePromasApiKey.type, handleUpdateApiKey);
}
